<template>
  <div id="app">
    <NavBar v-if="token != null" />
    <div class="conteudo"><router-view></router-view></div>
    <Footer v-if="token != null" />
  </div>
</template>

<script>
import NavBar from "@/components/navbar/NavBar";
import Footer from "@/components/footer/Footer";

export default {
  name: "App",
  data() {
    return {
      token: "",
    };
  },
  components: {
    NavBar,
    Footer,
  },
  updated() {
    this.token = localStorage.getItem("token");
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100%;
  position: relative;
  /*
  text-align: center;
  margin-top: 60px;*/
}

.conteudo{
  padding-bottom: 15%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue